var render = function () {
  var _vm$props, _vm$props2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row-slider-new"
  }, [_c('BaseRowSlider', {
    attrs: {
      "list": (_vm$props = _vm.props) === null || _vm$props === void 0 ? void 0 : _vm$props.list,
      "offset-between-elements": (_vm$props2 = _vm.props) === null || _vm$props2 === void 0 ? void 0 : _vm$props2.offsetBetweenElements
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var el = _ref.el,
            index = _ref.index;
        return [_vm._t("default", null, {
          "el": el,
          "index": index
        })];
      }
    }, {
      key: "nav",
      fn: function (_ref2) {
        var prev = _ref2.prev,
            next = _ref2.next,
            isEnd = _ref2.isEnd,
            isStart = _ref2.isStart;
        return [_vm._t("nav", function () {
          return [_c('div', {
            staticClass: "row-slider-new__arrow row-slider-new__arrow_left",
            class: {
              'row-slider-new__arrow_hide': isStart
            },
            on: {
              "click": function ($event) {
                return prev(2);
              }
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "row-slider-new__arrow row-slider-new__arrow_right",
            class: {
              'row-slider-new__arrow_hide': isEnd
            },
            on: {
              "click": function ($event) {
                return next(2);
              }
            }
          })];
        })];
      }
    }], null, true)
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }